import { useEffect } from "react";
import { useAppDispatch } from "../store";
import { useSelector } from "react-redux";
import { logoutUserThunk, selectMe } from "@adm-media/adam-store-plugin";
import { useDeleteQuery } from "./useDeleteQuery";
import { PathQueryParams } from "../pages";
export var useHandleErrors = function () {
    var dispatch = useAppDispatch();
    var errorMe = useSelector(selectMe).error;
    var deleteQuery = useDeleteQuery().deleteQuery;
    // Me errors
    useEffect(function () {
        if ((errorMe === null || errorMe === void 0 ? void 0 : errorMe.status) === 463 || (errorMe === null || errorMe === void 0 ? void 0 : errorMe.status) === 403 || (errorMe === null || errorMe === void 0 ? void 0 : errorMe.status) === 401) {
            dispatch(logoutUserThunk())
                .unwrap()
                .catch(function () { })
                .finally(function () {
                deleteQuery(PathQueryParams.edl);
                window.location.reload();
            });
        }
    }, [errorMe]);
};
